// extracted by mini-css-extract-plugin
module.exports = {"image":"SingleImage_image__kb9hc"};